var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cache-name"},[_c('p',{staticClass:"label"},[_vm._v("保存成功后，可在草稿处使用")]),_c('el-input',{attrs:{"placeholder":"请输入草稿名称","clearable":""},on:{"input":_vm.onEmit},model:{value:(_vm.draftName),callback:function ($$v) {_vm.draftName=$$v},expression:"draftName"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }